"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../../themes/Theme"));
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var theme = {
  container: {
    position: "relative",
    width: "100%",
    flex: "1 0 auto"
  },
  input: {
    width: "100%",
    height: "38px",
    borderRadius: "4px",
    border: "solid 1px #d2d2d2",
    backgroundColor: "#ffffff",
    paddingLeft: "10px",
    fontFamily: "Helvetica",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    color: "#495057",
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px"
  },
  inputFocused: {
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.2)",
    border: "solid 1px #2b77eb",
    backgroundColor: "#fbf8cb",
    color: "#495057",
    fontStyle: "normal",
    fontWeight: 400
  },
  inputOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  suggestionsContainer: {
    display: "none"
  },
  suggestionsContainerOpen: {
    display: "block",
    position: "absolute",
    width: "100%",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.2)",
    border: "solid 1px #2b77eb",
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    maxHeight: "201px",
    overflowY: "auto",
    zIndex: 15
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
  suggestion: {
    cursor: "pointer",
    padding: "10px 20px"
  },
  suggestionHighlighted: {
    backgroundColor: "#ddd"
  }
};
var SearchWrapper = _styledComponents["default"].div.withConfig({
  displayName: "BestQuickSearch__SearchWrapper",
  componentId: "sc-1kbnupq-0"
})(["display:flex;align-items:center;.quick-search-input::placeholder{color:", " !important;font-weight:", " !important;opacity:1 !important;font-style:italic !important;}"], function (props) {
  return props.theme.placeholder["color"];
}, function (props) {
  return props.theme.placeholder["fontWeight"];
});
var SelectButton = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "BestQuickSearch__SelectButton",
  componentId: "sc-1kbnupq-1"
})(["transform:translateX(-27px);"]);
var BestQuickSearch = function BestQuickSearch(_ref) {
  var options = _ref.options,
    suggestions = _ref.suggestions,
    renderSuggestion = _ref.renderSuggestion,
    getSuggestionValue = _ref.getSuggestionValue,
    getSuggestions = _ref.getSuggestions,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    onEnter = _ref.onEnter,
    onClear = _ref.onClear,
    onSuggestionSelected = _ref.onSuggestionSelected,
    searchValue = _ref.searchValue,
    clearable = _ref.clearable,
    styles = _ref.styles;
  var _useState = (0, _react.useState)(searchValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    localSuggestions = _useState4[0],
    setLocalSuggestions = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    suggestionHighlighted = _useState6[0],
    setSuggestionHighlighted = _useState6[1];
  _react["default"].useEffect(function () {
    setValue(searchValue);
  }, [searchValue]); // Update the current value on change

  var onChangeFn = function onChangeFn(event, _ref2) {
    var newValue = _ref2.newValue;
    setValue(newValue);
    onChange(newValue);
  }; // Check key press events

  var onKeyPress = function onKeyPress(event) {
    var keyCode = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
    if (13 === keyCode && !suggestionHighlighted) {
      onEnter(event);
    }
  };
  var onSuggestionHighlighted = function onSuggestionHighlighted(_ref3) {
    var suggestion = _ref3.suggestion;
    setSuggestionHighlighted(true);
  }; //Update suggestions

  var onSuggestionsFetchRequested = function onSuggestionsFetchRequested(_ref4) {
    var value = _ref4.value;
    setLocalSuggestions(getSuggestions(options, value));
  }; //Clear the suggestions

  var onSuggestionsClearRequested = function onSuggestionsClearRequested() {
    setLocalSuggestions([]);
    setSuggestionHighlighted(false);
  };
  var handleClearClick = function handleClearClick() {
    setValue("");
    onClear(event);
  }; //Autosuggest will pass through all these props to the input.

  var inputProps = {
    placeholder: placeholder,
    className: "quick-search-input",
    value: value,
    onChange: onChangeFn,
    onKeyPress: onKeyPress
  };
  var mergeStyleObject = function mergeStyleObject(defaultObj, newObj, field) {
    if (_typeof("") === _typeof(newObj[field])) {
      return newObj[field];
    } else {
      return _objectSpread({}, defaultObj[field], {}, newObj[field]);
    }
  };
  var mergeStyles = function mergeStyles(theme, styles) {
    return {
      container: mergeStyleObject(theme, styles, "container"),
      input: mergeStyleObject(theme, styles, "input"),
      inputFocused: mergeStyleObject(theme, styles, "inputFocused"),
      inputOpen: mergeStyleObject(theme, styles, "inputOpen"),
      suggestionsContainer: mergeStyleObject(theme, styles, "suggestionsContainer"),
      suggestionsContainerOpen: mergeStyleObject(theme, styles, "suggestionsContainerOpen"),
      suggestionsList: mergeStyleObject(theme, styles, "suggestionsList"),
      suggestion: mergeStyleObject(theme, styles, "suggestion"),
      suggestionHighlighted: mergeStyleObject(theme, styles, "suggestionHighlighted")
    };
  };
  var FinalTheme = mergeStyles(theme, styles);
  var finalSuggestions = suggestions ? suggestions : localSuggestions;
  return _react["default"].createElement(SearchWrapper, null, _react["default"].createElement(_reactAutosuggest["default"], {
    theme: FinalTheme,
    suggestions: finalSuggestions,
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    getSuggestionValue: getSuggestionValue,
    renderSuggestion: renderSuggestion,
    inputProps: inputProps,
    onSuggestionHighlighted: onSuggestionHighlighted,
    onSuggestionSelected: onSuggestionSelected
  }), clearable ? _react["default"].createElement(_react["default"].Fragment, null, value.length >= 1 ? _react["default"].createElement(SelectButton, {
    iconName: "fa-times-circle",
    onClick: handleClearClick
  }) : null) : _react["default"].createElement(SelectButton, {
    iconName: "fa-angle-down",
    styles: {
      color: _Theme["default"]["grey"],
      hoverColor: _Theme["default"]["dark-grey"]
    }
  }));
};
BestQuickSearch.defaultProps = {
  suggestions: null,
  placeholder: "",
  onChange: function onChange() {},
  onEnter: function onEnter() {},
  onClear: function onClear() {},
  clearable: true,
  styles: {
    container: {},
    input: {},
    inputFocused: {},
    inputOpen: {},
    suggestionsContainer: {},
    suggestionsContainerOpen: {},
    suggestionsList: {},
    suggestion: {},
    suggestionHighlighted: {}
  },
  searchValue: ""
};
BestQuickSearch.propTypes = {
  options: _propTypes["default"].array.isRequired,
  suggestions: _propTypes["default"].array,
  renderSuggestion: _propTypes["default"].func.isRequired,
  getSuggestionValue: _propTypes["default"].func.isRequired,
  getSuggestions: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onEnter: _propTypes["default"].func,
  onClear: _propTypes["default"].func,
  onSuggestionSelected: _propTypes["default"].func.isRequired,
  styles: _propTypes["default"].object,
  searchValue: _propTypes["default"].string,
  clearable: _propTypes["default"].bool
};
var _default = BestQuickSearch;
exports["default"] = _default;